module.exports = __webpack_public_path__ + "static/media/rui-icon.f7243d15.png";